import { render } from "./Copac13.vue?vue&type=template&id=30c6db2f"
import script from "./Copac13.vue?vue&type=script&lang=js"
export * from "./Copac13.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__